import { useRole, useOrg } from 'hooks';

const useShowBillingContactFlag = () => {
  const { sourcerRole, supplierRole } = useRole();
  const org = useOrg();

  return (
    (sourcerRole && org?.sourcerViewBillingContact) ||
    (supplierRole && org?.supplierViewBillingContact)
  );
};

export default useShowBillingContactFlag;
